import socket from '../dashboardSocket'
import {Watcher} from '../redux'
import {
  AUTH_LIST_UPDATE,
  AUTH_ADD_OR_UPDATED,
  DISMISS_ALERTS,
  UPDATE_FILTERS,
  DELETE_LISTING_GROUP,
  ADD_PAGE_MENTION,
  REMOVE_PAGE_MENTION
} from './constants'
import {convertProviderNiceNameToDBName} from "../../../modules/social/socialConstants";
import * as oauthHandshake from '../../../services/session/oauthHandshake'
import {PERMISSION_CHATTER} from '../../../services/session/oauthHandshake'
import req from "../req";
import SocialPublishingStore from "../../../modules/social/store/SocialPublishingStore";
import PublishingGroup from "../../../modules/social/models/PublishingGroup";
import SessionStore from "../../../services/session/SessionStore";

export default class SettingsChannel {
  constructor(store) {
    this.store = store;
    this.isStarted = false;
    this.dismissSuccessfulAdd = this.dismissSuccessfulAdd.bind(this);
    window.addTwitterCustomSearch = (text) => this.addTwitterCustomSearch(text);
    window.removeTwitterCustomSearch = (text) => this.removeTwitterCustomSearch(text);
  }

  start() {
    if (!this.isStarted) {
      this.isStarted = true;
      //this was moved to chatter container SocialPublishingStore.loadSocialPublishingData(undefined);
      socket.stream('/chatter/settings/subscribe', 'not/implemented') (({ body }) => {
        this.store.dispatch({
          type: AUTH_LIST_UPDATE,
          payload: body
        })
      });
    }
  }

  updatePending() {
    SocialPublishingStore.incrementAccountPendingCount();
  }

  updateComplete() {
    SocialPublishingStore.decrementAccountPendingCount();
  }

  refreshSettingsList() {
    SocialPublishingStore.resetAccountPendingCount();
  }

  removeAuth(auth) {
    this.updatePending();
    socket.sendExpectingResponse('/chatter/settings/removeAuth', { authId: auth._id }).then((response) => {
      return this.validateResponseThenComplete(response,true)
    })
  }

  addProviderCredentials(provider) {
    return oauthHandshake
      .requestUserAccessFromProvider(provider, [PERMISSION_CHATTER], SessionStore.account.accountId)
      .then(auth => this.store.dispatch({
        type: AUTH_ADD_OR_UPDATED,
        auth
      }))
  }

  addTwitterCustomSearch = async (text) => {
    this.updatePending();
    const response = await socket.sendExpectingResponse('/chatter/settings/twitter/addSearch', {mention: text});
    const validateResponse = await this.validateResponseThenComplete(response);
    const customSearchId = validateResponse.body._id.$oid;
    SocialPublishingStore.backfillIdForTwitterCustomSearch(customSearchId, text);
    this.store.dispatch({type: ADD_PAGE_MENTION, provider: 'Twitter', mention: text});
    return validateResponse;
  };

  dismissSuccessfulAdd(provider) {
    this.store.dispatch({type: DISMISS_ALERTS, provider});
  }

  removeTwitterCustomSearch = async (text) => {
    this.updatePending();
    const response = await socket.sendExpectingResponse('/chatter/settings/twitter/removeSearch', text);
    await this.validateResponseThenComplete(response);
    this.store.dispatch({type: REMOVE_PAGE_MENTION, provider: 'Twitter', mention: text});
  };

  validateResponse({ statusCode, body, errorReducerMethod }) {
    return processBodyIfValid => {
      if (statusCode < 200 || statusCode > 299) {
        // shouldn' this return a Promise.reject?
        console.error('kaboom', event);
        SocialPublishingStore.decrementAccountPendingCount();
        SocialPublishingStore.setErrorMessage(
          `
          An unexpected error occurred! Received response code ${statusCode}. If the problem persists, please
          contact support. Details: ${JSON.stringify(body)}
          `
        );
      } else {
        // in a Promise chain... you should not have to curry a callback, just return the body and use a .then
        return processBodyIfValid(body)
      }
    }
  }

  validateResponseThenComplete(response, refresh) {
    return this.validateResponse(response)(() => {
      this.updateComplete();
      if (refresh) {
        this.refreshSettingsList();
      }
      return response;
    });
  }

  handleListingGroupResponse(resp, fieldName, crudType) {
      resp.json().then(body => {
        this.validateListingGroupResponse({statusCode: resp.status, body, crudType})(() => {
          SocialPublishingStore.decrementAccountPendingCount();
        })
      })
  }

  validateListingGroupResponse({ statusCode, body, crudType}) {
    return processBodyIfValid => {
      if (statusCode < 200 || statusCode > 299) {
        console.error('kaboom', body);
        SocialPublishingStore.decrementAccountPendingCount();
        SocialPublishingStore.setErrorMessage(
          `Error ${crudType.split(/e$/)[0]}ing listing group. Details: ${body.msg}`
        );
      } else {
        if (crudType === 'add') {
          const group = new PublishingGroup(
            `Group:${body._id.$oid}`,
            body._id.$oid,
            body.accountId,
            body.remoteIds,
            body.name,
            convertProviderNiceNameToDBName(body.provider),
            null
          );
          SocialPublishingStore.addPublishingGroup(group);
        }

        return processBodyIfValid(body)
      }
    }
  }

  addListingGroup(listingGroup) {
    listingGroup._id = undefined; // Let the backend create a new id
    let requestToken = 'add';
    let accountId = listingGroup.accountId
      || SessionStore.account.accountId;
    this.updatePending();
    return fetch(
      req.json(
        `/chatter/settings/listingGroups/${requestToken}`,
        { body: {...listingGroup, accountId}, method: 'POST' }
        )
    ).then(resp => this.handleListingGroupResponse(resp,'listingGroup', 'add'));
  }

  updateListingGroup(listingGroup) {
    let requestToken = 'update';
    let accountId = listingGroup.accountId
      || SessionStore.account.accountId;
    this.updatePending();
    return fetch(
      req.json(
        `/chatter/settings/listingGroups/${requestToken}`,
        {body:{...listingGroup, accountId}, method: 'PUT'}
      )
    ).then(resp => this.handleListingGroupResponse(resp,'listingGroup','update'));
  }

  deleteListingGroup(id) {
    this.updatePending();

    return fetch(
      req(`/chatter/settings/listingGroups/delete/${id}`, {method: 'DELETE'})
    ).then(resp => {
      this.handleListingGroupResponse(resp, DELETE_LISTING_GROUP,'delete');
    })
  }

  toggleCredentialPage(credentialPageId, isDisabled) {
    this.updatePending();
    return socket
      .sendExpectingResponse('/chatter/settings/credentialPage/isDisabled', {
        credentialPageId, isDisabled
      })
      .then(response => this.validateResponseThenComplete(response))
  }

  updateFilters(update) {
    this.store.dispatch({
      type: UPDATE_FILTERS,
      update
    })
  }

}
